import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const homeConfig: HomePageConfig = {
  theme: {
    homeBg: '',
    tagsBg: '',
    tagActiveBg: brandTheme.primaryColor,
    tagActiveText: brandTheme.textInverse,
    tagInactiveBg: '#FDF0F4',
    tagInactiveText: '#9C8590',
    commonTagText: '#C93F68',
    tabActiveGradient: brandTheme.primaryGradient || brandTheme.primaryColor,
    tabActiveColor: '#402A33',
    showTabUnderline: true,
    stickyHeaderBg: 'linear-gradient(180deg, #FDF6F7 82%, rgba(253,246,247,0.94) 100%)',
    primaryGradient: brandTheme.primaryGradient,
  },
  texts: homeCommonConfig.texts,
}
